import type { Alignment } from "../flyout/types";
import type { Align } from "./types";

export const mapAlign = (align: Align): Alignment =>
  align === "left" ? "start" : "end";
